/** 所有页面通用的JS代码端放在这里
 * ...
 */

// pathname 与 中文名字的映射
const pageNameMap = [
    ['【销立方-首页】', '/', '/index', '/index.html'],
    ['销立方-产品系统】', '/product.html'],
    ['【销立方-关于我们页】', '/about.html'],
    ['【销立方-招商加盟页】', '/join.html'],
    ['【销立方-渠道合作页】', '/cooperation.html'],
    ['【销立方-客户案列页】', '/gustomer.html'],
    ['【销立方-论坛动态】', '/article/begin/articleList']
]



console.log(window.location.pathname)
for (let i = 0, pageNameMapLen = pageNameMap.length; i < pageNameMapLen; i++) {
    let handle = pageNameMap[i]
    for (let j = 0, handleLen = handle.length; j < handleLen; j++) {
        if (handle[j] === window.location.pathname) {
            window.pageNamePrefix = handle[0]
        }
    }
}
console.log(window.pageNamePrefix || '【销立方-未知页面】')